'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemShippingsIfNeeded = exports.isItemShippingLoading = exports.getLoadTimeForItemShipping = exports.getItemShipping = exports.LOAD_ITEM_SHIPPING_SUCCESS = exports.LOAD_ITEM_SHIPPING_REQUEST = exports.LOAD_ITEM_SHIPPING_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_SHIPPING_FAIL = exports.LOAD_ITEM_SHIPPING_FAIL = 'la/domain/itemShipping/LOAD_FAIL';
var LOAD_ITEM_SHIPPING_REQUEST = exports.LOAD_ITEM_SHIPPING_REQUEST = 'la/domain/itemShipping/LOAD_REQUEST';
var LOAD_ITEM_SHIPPING_SUCCESS = exports.LOAD_ITEM_SHIPPING_SUCCESS = 'la/domain/itemShipping/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_SHIPPING_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_ITEM_SHIPPING_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_ITEM_SHIPPING_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.itemShippings) {
                action.payload.itemShippings.forEach(function (x) {
                    existing[x.itemId] = (0, _extends3.default)({}, x);
                    loaded[x.itemId] = time;
                    loading = (0, _difference2.default)(loading, [x.itemId]);
                });
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.itemShipping;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and passes both params to every function on
// the way down.
var getItemShipping = exports.getItemShipping = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForItemShipping = exports.getLoadTimeForItemShipping = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemShippingLoading = exports.isItemShippingLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchItemShipping = function shouldFetchItemShipping(state, itemId) {
    if (!itemId) return false;
    var item = getItemShipping(state, itemId);
    if (item) {
        var loaded = getLoadTimeForItemShipping(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemShippingLoading(state, itemId);
    return !loading;
};

var whichItemShippingsNeeded = function whichItemShippingsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItemShipping(state, itemId);
    });
};

/* ACTION CREATORS */
var loadItemShippings = function loadItemShippings(itemIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            payload: itemIds,
            type: LOAD_ITEM_SHIPPING_REQUEST
        });
        return _api.Item.fetchItemShippingsByIds({ deployment: deployment, itemIds: itemIds }).then(function (response) {
            dispatch({
                meta: { actionTime: Date.now(), itemIds: itemIds },
                payload: response.data,
                type: LOAD_ITEM_SHIPPING_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                meta: { itemIds: itemIds },
                payload: error,
                type: LOAD_ITEM_SHIPPING_FAIL
            });
        });
    };
};

var fetchItemShippingsIfNeeded = exports.fetchItemShippingsIfNeeded = function fetchItemShippingsIfNeeded(itemIds) {
    return function (dispatch, getState) {
        var needed = whichItemShippingsNeeded(getState(), itemIds);
        if (needed.length) {
            return dispatch(loadItemShippings(needed));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/itemShipping.js
// module id = YcIK
// module chunks = 57